import { render, staticRenderFns } from "./ResetStaffPwd.vue?vue&type=template&id=47c61d62"
import script from "./ResetStaffPwd.vue?vue&type=script&lang=js"
export * from "./ResetStaffPwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports